var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeeds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.3801C13.3144 14.3801 14.38 13.3146 14.38 12.0001C14.38 10.6857 13.3144 9.62012 12 9.62012C10.6856 9.62012 9.62 10.6857 9.62 12.0001C9.62 13.3146 10.6856 14.3801 12 14.3801Z",
    fill: "#3C435C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 18.7503C19.84 18.7503 19.69 18.7003 19.55 18.6003C19.22 18.3503 19.15 17.8803 19.4 17.5503C20.61 15.9403 21.25 14.0203 21.25 12.0003C21.25 9.98028 20.61 8.06029 19.4 6.45029C19.15 6.12029 19.22 5.65028 19.55 5.40028C19.88 5.15028 20.35 5.22027 20.6 5.55027C22.01 7.42027 22.75 9.65028 22.75 12.0003C22.75 14.3503 22.01 16.5803 20.6 18.4503C20.45 18.6503 20.23 18.7503 20 18.7503Z",
    fill: "#3C435C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4 18.7503C3.77 18.7503 3.54999 18.6503 3.39999 18.4503C1.98999 16.5803 1.25 14.3503 1.25 12.0003C1.25 9.65028 1.98999 7.42027 3.39999 5.55027C3.64999 5.22027 4.12001 5.15028 4.45001 5.40028C4.78001 5.65028 4.85001 6.12029 4.60001 6.45029C3.39001 8.06029 2.75 9.98028 2.75 12.0003C2.75 14.0203 3.39001 15.9403 4.60001 17.5503C4.85001 17.8803 4.78001 18.3503 4.45001 18.6003C4.32001 18.7003 4.16 18.7503 4 18.7503Z",
    fill: "#3C435C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.8001 16.3497C16.6401 16.3497 16.4901 16.2997 16.3501 16.1997C16.0201 15.9497 15.9501 15.4797 16.2001 15.1497C16.8901 14.2397 17.2501 13.1497 17.2501 11.9997C17.2501 10.8497 16.8901 9.7597 16.2001 8.8497C15.9501 8.5197 16.0201 8.04968 16.3501 7.79968C16.6801 7.54968 17.1501 7.6197 17.4001 7.9497C18.2801 9.1297 18.7501 10.5297 18.7501 11.9997C18.7501 13.4697 18.2801 14.8797 17.4001 16.0497C17.2501 16.2497 17.0301 16.3497 16.8001 16.3497Z",
    fill: "#3C435C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.20001 16.3497C6.97001 16.3497 6.75001 16.2497 6.60001 16.0497C5.72001 14.8697 5.25 13.4697 5.25 11.9997C5.25 10.5297 5.72001 9.1197 6.60001 7.9497C6.85001 7.6197 7.31999 7.54968 7.64999 7.79968C7.97999 8.04968 8.04999 8.5197 7.79999 8.8497C7.10999 9.7597 6.75 10.8497 6.75 11.9997C6.75 13.1497 7.10999 14.2397 7.79999 15.1497C8.04999 15.4797 7.97999 15.9497 7.64999 16.1997C7.51999 16.2997 7.36001 16.3497 7.20001 16.3497Z",
    fill: "#3C435C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeds);
export default __webpack_public_path__ + "static/media/feeds.3334298f5f50eedb2be22439ea0c5db6.svg";
export { ForwardRef as ReactComponent };